import { VehicleUserModule } from '@/../refactor-dist/refactor-module';
import PreferredLocationsModule from '@/domains/Carsharing/views/Booking/store/PreferredLocations/PreferredLocationsModule';

const GENERAL_MODULE = 'Signup/General';
const EMPLOYEE_MODULE = 'Signup/Employee';
const COMPANY_MODULE = 'Signup/Company';
const VIEWS_MODULE_NAMESPACE = 'ViewsModule';
const VEHICLE_USER_MODULE = `${VIEWS_MODULE_NAMESPACE}/${VehicleUserModule.NAMESPACE}`;
const PREFERRED_LOCATIONS_MODULE = `${VIEWS_MODULE_NAMESPACE}/${PreferredLocationsModule.NAMESPACE}`;

export {
  GENERAL_MODULE,
  EMPLOYEE_MODULE,
  COMPANY_MODULE,
  VIEWS_MODULE_NAMESPACE,
  VEHICLE_USER_MODULE,
  PREFERRED_LOCATIONS_MODULE
};
